/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Theme_Glacier_LabelInputs */

const bn_theme_glacier_label = /** @type {(inputs: Theme_Glacier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হিমবাহ`)
};

const de_theme_glacier_label = /** @type {(inputs: Theme_Glacier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gletscher`)
};

const el_theme_glacier_label = /** @type {(inputs: Theme_Glacier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Παγετώνας`)
};

const en_theme_glacier_label = /** @type {(inputs: Theme_Glacier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glacier`)
};

const es_theme_glacier_label = /** @type {(inputs: Theme_Glacier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glaciar`)
};

const fr_theme_glacier_label = /** @type {(inputs: Theme_Glacier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glacier`)
};

const hi_theme_glacier_label = /** @type {(inputs: Theme_Glacier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिमनद`)
};

const hu_theme_glacier_label = /** @type {(inputs: Theme_Glacier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gleccser`)
};

const id_theme_glacier_label = /** @type {(inputs: Theme_Glacier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gletser`)
};

const it_theme_glacier_label = /** @type {(inputs: Theme_Glacier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghiacciaio`)
};

const ja_theme_glacier_label = /** @type {(inputs: Theme_Glacier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`氷河`)
};

const ko_theme_glacier_label = /** @type {(inputs: Theme_Glacier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빙하`)
};

const nl_theme_glacier_label = /** @type {(inputs: Theme_Glacier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gletsjer`)
};

const pl_theme_glacier_label = /** @type {(inputs: Theme_Glacier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lodowiec`)
};

const pt_theme_glacier_label = /** @type {(inputs: Theme_Glacier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geleira`)
};

const ru_theme_glacier_label = /** @type {(inputs: Theme_Glacier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ледник`)
};

const sv_theme_glacier_label = /** @type {(inputs: Theme_Glacier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glaciär`)
};

const tr_theme_glacier_label = /** @type {(inputs: Theme_Glacier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buzul`)
};

const uk_theme_glacier_label = /** @type {(inputs: Theme_Glacier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Льодовик`)
};

const vi_theme_glacier_label = /** @type {(inputs: Theme_Glacier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sông băng`)
};

const zh_theme_glacier_label = /** @type {(inputs: Theme_Glacier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`冰川`)
};

const zh_hant_theme_glacier_label = /** @type {(inputs: Theme_Glacier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`冰河`)
};

/**
* | output |
* | --- |
* | "Glacier" |
*
* @param {Theme_Glacier_LabelInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const theme_glacier_label = /** @type {((inputs?: Theme_Glacier_LabelInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Theme_Glacier_LabelInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_theme_glacier_label(inputs)
	if (locale === "de") return de_theme_glacier_label(inputs)
	if (locale === "el") return el_theme_glacier_label(inputs)
	if (locale === "en") return en_theme_glacier_label(inputs)
	if (locale === "es") return es_theme_glacier_label(inputs)
	if (locale === "fr") return fr_theme_glacier_label(inputs)
	if (locale === "hi") return hi_theme_glacier_label(inputs)
	if (locale === "hu") return hu_theme_glacier_label(inputs)
	if (locale === "id") return id_theme_glacier_label(inputs)
	if (locale === "it") return it_theme_glacier_label(inputs)
	if (locale === "ja") return ja_theme_glacier_label(inputs)
	if (locale === "ko") return ko_theme_glacier_label(inputs)
	if (locale === "nl") return nl_theme_glacier_label(inputs)
	if (locale === "pl") return pl_theme_glacier_label(inputs)
	if (locale === "pt") return pt_theme_glacier_label(inputs)
	if (locale === "ru") return ru_theme_glacier_label(inputs)
	if (locale === "sv") return sv_theme_glacier_label(inputs)
	if (locale === "tr") return tr_theme_glacier_label(inputs)
	if (locale === "uk") return uk_theme_glacier_label(inputs)
	if (locale === "vi") return vi_theme_glacier_label(inputs)
	if (locale === "zh") return zh_theme_glacier_label(inputs)
	return zh_hant_theme_glacier_label(inputs)
});